module.exports = __webpack_public_path__ + "assets/img/移动端.6d684534.png";